import React from 'react';

const MacroBar = ({ label, value, goal, color }) => {
  const percent = Math.min(100, (value / goal) * 100);
  const size = 64;
  const stroke = 6;
  const radius = (size - stroke) / 2;
  const c = 2 * Math.PI * radius;
  const off = c * (1 - percent / 100);

  return (
    <div className="flex flex-col items-center">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={radius} stroke="#eef2f7" strokeWidth={stroke} fill="none" />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={color}
            strokeWidth={stroke}
            fill="none"
            strokeLinecap="round"
            strokeDasharray={c}
            strokeDashoffset={off}
            style={{ transition: 'stroke-dashoffset 800ms cubic-bezier(0.22, 1, 0.36, 1)' }}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-xs font-bold text-gray-900">{Math.round(percent)}%</span>
        </div>
      </div>
      <p className="text-xs font-semibold text-gray-900 mt-2">{label}</p>
      <p className="text-[11px] text-gray-500">{value} / {goal}g</p>
    </div>
  );
};

export default MacroBar;
